import Service from '@ember/service';

import * as Sentry from '@sentry/ember';

export default class SentryService extends Service {
  captureException(error, context = {}) {
    Sentry.captureException(error, context);
  }
}
